import { BodyType, customInstance } from '@/features/auth/axios-config'
import {
  RequestListRoles,
  SuccessResponsePaginatedResponseResponseRoleList,
} from '@/schema'

export type SecondParameter<T extends (...args: never) => unknown> =
  Parameters<T>[1]

/**
 * List roles from local RBAC database with hierarchical scope filtering:
- `organization`: All roles (Organization Admin, Project Lead, Team Member, Reviewer, Viewer)
- `project`: Project-level roles (Project Lead, Team Member, Reviewer)
- `deliverable_set`: Deliverable-level roles (Team Member, Reviewer)

Supports search, filtering, sorting, and pagination. Returns roles without permissions.
 * @summary List all roles with optional scope-level filtering
 */
export const listRoles = (
  requestListRoles: BodyType<RequestListRoles>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SuccessResponsePaginatedResponseResponseRoleList>(
    {
      url: `/admin/v1/roles/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestListRoles,
      signal,
    },
    options
  )
}
